// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10T6f","question":"styles_question__3nzwk","description":"styles_description__2RhVX"};